/**
 * get the publish settings ID
 */
export const PUBLISHING_SETTINGS_ID: string = '2d504595-5a19-4106-bfef-6d3f40a9ba60';

/**
 * get the publish settings name
 */
export const PUBLISHING_SETTINGS_NAME: string = 'PUBLISHING_SETTINGS';
